import * as React from "react";
import {Stack, Typography} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {truncateStr} from "../Service";

const InformationBox = ({icon, alt, label, info, info2}) => {
    const {mode} = useDarkMode();
    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-start'}>
            <img src={`/assets/icon/${icon}.png`} alt={alt} className={'profile-icon'}/>
            <Typography
                color={mode.settings.textColor3}
                width={180}
                display={{xs : 'none', md : 'none', lg : 'block'}}
            >
                {label}
            </Typography>
            <Stack>
                <Typography
                    color={mode.settings.textColor3}
                    variant={'body2'}
                    style={{marginLeft:'20px'}}
                    sx={{
                        width: {xs : '200px', md : '100%', lg : '100%'},
                        textOverflow: 'ellipsis',
                        overflow: 'hidden'
                    }}
                >
                    { info }
                </Typography>
                {info2 && <Typography
                    color={mode.settings.textColor3}
                    variant={'body2'}
                    style={{marginLeft:'20px'}}
                    sx={{
                        width: {xs : '200px', md : '100%', lg : '100%'},
                        textOverflow: 'ellipsis',
                        overflow: 'hidden'
                    }}
                >
                    { info2 }
                </Typography>}
            </Stack>

        </Stack>
    )
}

export default InformationBox;
